<article class="wrapper__article">
  <div class="wrapper__article__content">
    <mat-tab-group (selectedIndexChange)="onSelectTab($event)">
      <mat-tab *ngFor="let tab of loadingRouteTabs | keyvalue: asIsOrder" [label]="tab.value">
        <app-cargo-list *ngIf="activeTab === tab.value" [typeList]="tab.key"></app-cargo-list>
      </mat-tab>
    </mat-tab-group>
  </div>
</article>
